import { render } from "./orderSpec.vue?vue&type=template&id=5a79cc2c&scoped=true"
import script from "./orderSpec.vue?vue&type=script&lang=js"
export * from "./orderSpec.vue?vue&type=script&lang=js"

import "./orderSpec.vue?vue&type=style&index=0&id=5a79cc2c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5a79cc2c"]])

export default __exports__